import { render, staticRenderFns } from "./uploadAnnex.vue?vue&type=template&id=073f68fa&scoped=true"
import script from "./uploadAnnex.vue?vue&type=script&lang=js"
export * from "./uploadAnnex.vue?vue&type=script&lang=js"
import style0 from "./uploadAnnex.vue?vue&type=style&index=0&id=073f68fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f68fa",
  null
  
)

export default component.exports